<template>
  <div id="sns-conteiner">
    <ol>
      <li v-for="item in items"
      v-on:click="onClick(item.path)"
      > {{ item.name }}
    </li>
    </ol>
  </div>
</template>

<script>

export default {
  name: 'SnsFieldMobile',
  data () {
    return {
      title: 'this will head',
      items: [
        { name: 'twitter', icon: require('../assets/sns_logos/twitter.png'), path: 'https://twitter.com/churabou1' },
        { name: 'facebook', icon: require('../assets/sns_logos/facebook.png'), path: 'https://www.facebook.com' },
        { name: 'instagram', icon: require('../assets/sns_logos/instagram.png'), path: 'https://www.instagram.com/' },
        { name: 'github', icon: require('../assets/sns_logos/github.png'), path: 'https://github.com/churabou' },
        { name: 'hatenablog', icon: require('../assets/sns_logos/hatenablog.png'), path: 'https://churabou.hatenablog.com/'},
      ]
    }
  },

  methods: {
    onClick: function(path) {
      window.location.href = path
    }
  }
}

</script>

<style scoped>

div {
  text-align: center;
  /* background-color: orange; */
}

#sns-conteiner ol {
  /* list-style-position: inside; */
  /* background-color: green; */
  margin-top: 30px;
  display:flex;
  justify-content: center;
  padding: 0;
  list-style: none
}

#sns-conteiner li {
  width: 46px;
  height: 46px;
  margin-left:5px;
  margin-right:5px;
  font-size: 10px;
  border-radius: 23px;
  background-color: lime;
  color: white;
  line-height: 46px
}

#sns-conteiner li:hover {
  background-color: pink;
}


/*  WEBなら*/
@media screen and (min-width:781px) {
  #sns-conteiner  {
    background-color: red;
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SnsFieldMobile.vue